export const BLACK_FRIDAY_STATUS = 'BLACK_FRIDAY';
export const OFF_STATUS = 'OFF';
export const ON_STATUS = 'ON';
